import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PostPurchaseWrapper} from '../../../../model/postPurchaseWrapper';
import {UpdatePostPurchaseVal} from '../../../../model/updatePostPurchaseVal';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../shared/error-page/service/error-service';
import {DeliveryWrapper} from '../../../../model/deliveryWrapper';
import {Constants} from '../../../../constants/ebtq-constants';
import {DecimalPipe} from '@angular/common';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-postpurchaseupdate',
  templateUrl: './postpurchaseupdate.component.html',
  styleUrls: ['./postpurchaseupdate.component.scss']
})
export class PostpurchaseupdateComponent implements OnInit {

  postPurchaseWrap: PostPurchaseWrapper;
  loanNumber: string;
  state: any[];
  selectedState: string;
  dwelType: any[];
  selectedDwel: string;
  units: any[];
  selectedUnit: string;
  borEthnicity: any[];
  selectedBorEthnicity: string;
  borGender: any[];
  selectedBorGender: string;
  borRace: any[];
  selectedBorRace: string;
  coBorEthnicity: any[];
  selectedCoBorEthnicity: string;
  CoBorGender: any[];
  selectedCoBorGender: string;
  coBorRace: any[];
  selectedCoBorRace: string;

  lendrLnId: string;
  oldFannieLn: string;
  fhaCaseNum: string;
  address: string;
  city: string;
  zip: string;
  yrBuilt: string;
  noOfRoom: string;
  monIncome: string;
  coBoDOB: string;

  lenLnIdVal: string;
  oldFnmaeLnIdVal: string;
  fhaCaseNoVal: string;
  addVal: string;
  cityVal: string;
  stateVal: string;
  zipVal: string;
  yrHouBuiltVal: string;
  noOfBedRmVal: string;
  noOfUnitVal: string;
  dwelTypeVal: string;
  monIncmVal: string;
  borrEthnicityVal: string;
  borrGendVal: string;
  displayBorrGendVal: string;
  borrRaceVal: string;
  coBorrEthniVal: string;
  coBorrgenVal: string;
  coBorrRaceVal: string;
  coBorrDobVal: string;
  updatePostPurchaseValues?: Array<UpdatePostPurchaseVal> = [];
  cols: any[];
  isUpdateForm = true;
  isUpdateConfirm = false;
  pageHeader: string;
  showErrorDiv = false;
  errHeading: string;
  validationMessages = [];
  formMap: Map<string, string>;

  title = 'Post Purchase Adjustments Update';

  constructor(private router: ActivatedRoute, private decimalPipe: DecimalPipe, private routers: Router,
              private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.errHeading = Constants.ERR_HEADER;
    this.isUpdateForm = true;
    this.isUpdateConfirm = false;
    this.pageHeader = 'Post Purchase Adjustments Update';
  }

  setOptionValue() {

    this.state = [];
    this.dwelType = [];
    this.units = [];
    this.borEthnicity = [];
    this.borGender = [];
    this.borRace = [];
    this.coBorEthnicity = [];
    this.CoBorGender = [];
    this.coBorRace = [];


    const stateVal: any[] = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
    for (const stateName of stateVal) {
      this.state.push({label: stateName, value: stateName});
    }

    this.units.push({label: '1', value: '1'});
    this.units.push({label: '2', value: '2'});
    this.units.push({label: '3', value: '3'});
    this.units.push({label: '4', value: '4'});

    this.dwelType.push({label: 'Condo', value: 'C'});
    this.dwelType.push({label: 'Single Family', value: 'S'});
    this.dwelType.push({label: 'PUD', value: 'P'});

    this.borEthnicity.push({label: 'Not Provided', value: '3'});
    this.borEthnicity.push({label: 'Not Hispanic or Latino', value: '2'});
    this.borEthnicity.push({label: 'Hispanic or Latino', value: '1'});


    this.borGender.push({label: 'Not Given', value: '3'});
    this.borGender.push({label: 'M', value: '1'});
    this.borGender.push({label: 'F', value: '2'});


    this.borRace.push({label: 'Not Provided', value: '6'});
    this.borRace.push({label: 'Asian', value: '2'});
    this.borRace.push({label: 'Black or African American', value: '3'});
    this.borRace.push({label: 'Native Hawaiian or Pacific Islander', value: '4'});
    this.borRace.push({label: 'White', value: '5'});
    this.borRace.push({label: 'American Indian or Alaskan Native', value: '1'});

    this.coBorEthnicity.push({label: 'Not Provided', value: '3'});
    this.coBorEthnicity.push({label: 'Not Hispanic or Latino', value: '2'});
    this.coBorEthnicity.push({label: 'Hispanic or Latino', value: '1'});
    this.coBorEthnicity.push({label: 'No Co-Borrower', value: '5'});

    this.CoBorGender.push({label: 'Not Given', value: '3'});
    this.CoBorGender.push({label: 'M', value: '1'});
    this.CoBorGender.push({label: 'F', value: '2'});
    this.CoBorGender.push({label: 'No Co-Borrower', value: '4'});

    this.coBorRace.push({value: ''});
    this.coBorRace.push({label: 'Not Provided', value: '6'});
    this.coBorRace.push({label: 'Asian', value: '2'});
    this.coBorRace.push({label: 'Black or African American', value: '3'});
    this.coBorRace.push({label: 'Native Hawaiian or Pacific Islander', value: '4'});
    this.coBorRace.push({label: 'White', value: '5'});
    this.coBorRace.push({label: 'American Indian or Alaskan Native', value: '1'});
    this.coBorRace.push({label: 'No Co-Borrower', value: '8'});

    this.loanNumber = this.postPurchaseWrap.fannieMaeLoanNumber;
    this.lenLnIdVal = this.postPurchaseWrap.lenderLoanID;
    if (this.postPurchaseWrap.oldFannieMaeLoanNumber != null)
    {this.oldFnmaeLnIdVal = this.postPurchaseWrap.oldFannieMaeLoanNumber;}
    this.fhaCaseNoVal = this.postPurchaseWrap.fhaCaseNumber;
    this.addVal = this.postPurchaseWrap.address;
    this.cityVal = this.postPurchaseWrap.city;
    this.stateVal = this.postPurchaseWrap.state;
    this.zipVal = this.postPurchaseWrap.zip;
    this.yrHouBuiltVal = this.postPurchaseWrap.yearBuild;
    this.noOfBedRmVal = this.postPurchaseWrap.numberOfBedrooms;
    this.noOfUnitVal = this.postPurchaseWrap.numberOfUnits;
    this.dwelTypeVal = this.dwelType.find(value => value.value === this.postPurchaseWrap.dwellingType).label;
    this.monIncmVal = this.postPurchaseWrap.monthlyIncome;
    this.borrEthnicityVal = this.borEthnicity.find(value => value.value === this.postPurchaseWrap.borrowerEthnicity).label;
    this.borrGendVal = this.borGender.find(value => value.value === this.postPurchaseWrap.borrowerGender).label;
    this.borrRaceVal = this.borRace.find(value => value.value === this.postPurchaseWrap.borrowerRace1).label;
    this.coBorrEthniVal = this.coBorEthnicity.find(value => value.value === this.postPurchaseWrap.coBorrowerEthnicity).label;
    this.coBorrDobVal = this.postPurchaseWrap.coBorrowerDOB;
    this.coBorrgenVal = this.CoBorGender.find(value => value.value === this.postPurchaseWrap.coBorrowerGender).label;
    this.coBorrRaceVal = this.coBorRace.find(value => value.value === this.postPurchaseWrap.coBorrowerRace1).label;

    if (this.borrGendVal === 'M') {
      this.displayBorrGendVal = 'Male';
    } else if (this.borrGendVal === 'F') {
      this.displayBorrGendVal = 'Female';
    } else {
      this.displayBorrGendVal = 'Not Given';
    }
  }

  ngOnInit(): void {
    this.clearBtn();
    this.titleService.setTitle(this.title);
    this.router.queryParams.subscribe(params => {
      this.postPurchaseWrap = JSON.parse(atob(params.query));
      this.setOptionValue();
      this.cdr.detectChanges();
    });
  }

  addToUpdatePostPurchaseValues(name: string, currentVal: any, newVal: any) {
    if (this.updatePostPurchaseValues.length === 0) {
      // Table column headings set as first object
      const updatePostPurchaseVal: UpdatePostPurchaseVal = new UpdatePostPurchaseVal();
      updatePostPurchaseVal.name = Constants.FIELD_HDR_NAME;
      updatePostPurchaseVal.currentVal = Constants.CUR_HDR_VAL;
      updatePostPurchaseVal.newVal = Constants.CUR_NEW_VAL;
      this.updatePostPurchaseValues.push(updatePostPurchaseVal);
    }
    const updatePostPurchaseVal: UpdatePostPurchaseVal = new UpdatePostPurchaseVal();
    updatePostPurchaseVal.name = name;
    updatePostPurchaseVal.currentVal = currentVal;
    updatePostPurchaseVal.newVal = newVal;
    this.updatePostPurchaseValues.push(updatePostPurchaseVal);
  }

  checkNull(param: any) {
    if (param == null || param === '') {
      return false;
    } else {
      return true;
    }
  }

  updateConfirmBtn() {
    if (this.validation()) {
      this.updatePostPurchaseValues = [];
      this.formMap = new Map<string, string>();

      if (this.checkNull(this.lendrLnId)) {
        this.addToUpdatePostPurchaseValues('Lender Loan Id', this.lenLnIdVal, this.lendrLnId);
        this.formMap.set('LNDR_LN_NO', this.lendrLnId);
      }
      if (this.checkNull(this.oldFannieLn)) {
        this.addToUpdatePostPurchaseValues('Old FannieLoan Id', this.oldFnmaeLnIdVal, this.oldFannieLn);
        this.formMap.set('PREV_FNM_LN_NO', this.oldFannieLn);
      }
      if (this.checkNull(this.fhaCaseNum)) {
        this.addToUpdatePostPurchaseValues('FHA Case number', this.fhaCaseNoVal, this.fhaCaseNum);
        this.formMap.set('FHA_CASE_NO', this.fhaCaseNum);
      }
      if (this.checkNull(this.address)) {
        this.addToUpdatePostPurchaseValues('Address', this.addVal, this.address);
        this.formMap.set('PROP_STR_ADDR', this.address);
      }
      if (this.checkNull(this.city)) {
        this.addToUpdatePostPurchaseValues('City', this.cityVal, this.city);
        this.formMap.set('PROP_CITY', this.city);
      }
      if (this.checkNull(this.selectedState)) {
        this.addToUpdatePostPurchaseValues('State', this.stateVal, this.selectedState);
        this.formMap.set('PROP_ST_CD', this.selectedState);
      }
      if (this.checkNull(this.zip)) {
        this.addToUpdatePostPurchaseValues('Zip', this.zipVal, this.zip);
        this.formMap.set('PROP_ZIP_CD', this.zip);
      }
      if (this.checkNull(this.yrBuilt)) {
        this.addToUpdatePostPurchaseValues('Year Build', this.yrHouBuiltVal, this.yrBuilt);
        this.formMap.set('PROP_STRC_BLT_YR', this.yrBuilt);
      }
      if (this.checkNull(this.noOfRoom)) {
        this.addToUpdatePostPurchaseValues('Number Of Bedrooms', this.noOfBedRmVal, this.noOfRoom);
        this.formMap.set('NO_OF_BDRM', this.noOfRoom);
      }
      if (this.checkNull(this.selectedUnit)) {
        this.addToUpdatePostPurchaseValues('Number Of Units', this.noOfUnitVal, this.units.find(value => value.value === this.selectedUnit).label);
        this.formMap.set('NO_OF_UNITS', this.selectedUnit);
      }
      if (this.checkNull(this.selectedDwel)) {
        this.addToUpdatePostPurchaseValues('Dwelling Type', this.dwelTypeVal, this.dwelType.find(value => value.value === this.selectedDwel).label);
        this.formMap.set('PROP_DWL_TYP_CD', this.selectedDwel);
      }
      if (this.checkNull(this.monIncome)) {
        this.addToUpdatePostPurchaseValues('MonthlyIncome', '$' + this.decimalPipe.transform(this.monIncmVal, '1.2-2'), '$' + this.decimalPipe.transform(this.monIncome, '1.2-2'));
        this.formMap.set('BRWR_INCM_MTHY_TOT_AMT', this.monIncome);
      }
      if (this.checkNull(this.selectedBorEthnicity)) {
        this.addToUpdatePostPurchaseValues('Borrower Ethnicity', this.borrEthnicityVal, this.borEthnicity.find(value => value.value === this.selectedBorEthnicity).label);
        this.formMap.set('BRWR_ETHCY_CD', this.selectedBorEthnicity);
      }
      if (this.checkNull(this.selectedBorGender)) {
        let gender = this.borGender.find(value => value.value === this.selectedBorGender).label;
        if (gender === 'M') {
          gender = 'Male';
        } else if (gender === 'F') {
          gender = 'FeMale';
        }
        let selGender = this.borrGendVal;
        if (selGender === 'M') {
          selGender = 'Male';
        } else if (selGender === 'F') {
          selGender = 'FeMale';
        }
        this.addToUpdatePostPurchaseValues('Borrower Gender', selGender, gender);
        this.formMap.set('BRWR_GNDR_TYP_CD', gender);
      }
      if (this.checkNull(this.selectedBorRace)) {
        this.addToUpdatePostPurchaseValues('Borrower Race', this.borrRaceVal, this.borRace.find(value => value.value === this.selectedBorRace).label);
        this.formMap.set('BRWR_RC_CD1', this.selectedBorRace);
      }
      if (this.checkNull(this.selectedCoBorEthnicity)) {
        this.addToUpdatePostPurchaseValues('Co-Borrower Ethnicity', this.coBorrEthniVal, this.coBorEthnicity.find(value => value.value === this.selectedCoBorEthnicity).label);
        this.formMap.set('CBRWR_ETHCY_CD', this.selectedCoBorEthnicity);
      }
      if (this.checkNull(this.selectedCoBorGender)) {
        let gender = this.CoBorGender.find(value => value.value === this.selectedCoBorGender).label;
        if (gender === Constants.GNDR_MAL_STR) {
          gender = Constants.GNDR_M_VAL;
        } else if (gender === Constants.GNDR_FMAL_STR) {
          gender = Constants.GNDR_F_VAL;
        }
        let selGender = this.coBorrgenVal;
        if (selGender === Constants.GNDR_MAL_STR) {
          selGender = Constants.GNDR_M_VAL;
        } else if (selGender === Constants.GNDR_FMAL_STR) {
          selGender = Constants.GNDR_F_VAL;
        }
        this.addToUpdatePostPurchaseValues('Co-Borrower Gendere', selGender, gender);
        this.formMap.set('CBRWR_GNDR_TYP_CD', this.selectedCoBorGender);
      }
      if (this.checkNull(this.selectedCoBorRace)) {
        this.addToUpdatePostPurchaseValues('Co-Borrower Race', this.coBorrRaceVal, this.coBorRace.find(value => value.value === this.selectedCoBorRace).label);
        this.formMap.set('CBRWR_RC_CD1', this.selectedCoBorRace);
      }

      if (this.checkNull(this.coBoDOB)) {
        this.addToUpdatePostPurchaseValues('Co-Borrower Date of Birth', this.coBorrDobVal, this.coBoDOB);
        this.formMap.set('CBRWR_BIR_DT', this.coBoDOB);
      }

      if (this.formMap.size > 0) {
        this.formMap.set('FNM_LN_NO', this.loanNumber);
        this.confirmationPage();
        this.selectedDwel = null;
        this.selectedState = null;
        this.selectedUnit = null;
        this.selectedBorEthnicity = null;
        this.selectedBorGender = null;
        this.selectedBorRace = null;
        this.selectedCoBorEthnicity = null;
        this.selectedCoBorGender = null;
        this.selectedCoBorRace = null;
      } else {
        this.showErrorDiv = true;
        this.validationMessages.push(Constants.PPA_NO_CHANGES_VAL);
      }
    }
  }

  confirmationPage() {
    this.pageHeader = 'Post Purchase Adjustments Confirmation';
    this.isUpdateForm = false;
    this.isUpdateConfirm = true;
    this.titleService.setTitle(this.pageHeader);
  }

  cancelConfirmBtn() {
    this.clearBtn();
    this.isUpdateForm = true;
    this.isUpdateConfirm = false;
    this.pageHeader = 'Post Purchase Adjustments Update';
    this.titleService.setTitle(this.pageHeader);
  }

  updateData() {
    const request = new DeliveryWrapper();
    const convMap = {};
    this.formMap.forEach((val: string, key: string) => {
      convMap[key] = val;
    });
    request.formMap = convMap;

    this.apiService.updatePPA(request)
      .subscribe(
        () => {
          this.routers.navigate(['postPurchaseAdj'], {
            queryParams: {query: btoa(JSON.stringify(this.loanNumber))}
          });
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {

      });

    this.titleService.setTitle('Post Purchase Adjustments');
  }

  dateValidator(c: string) {

    if ((c !== undefined && c !== '' && c != null)) {

      let month = null;
      let day = null;
      let year = null;
      if (c.indexOf('/') > -1) {
        if (c.indexOf('/') !== 2 || c.lastIndexOf('/') !== 5) {
          return true;
        }
        const res = c.split('/');
        if (res.length > 1) {
          month = res[0];
          day = res[1];
          year = res[2];
        }
      } else {
        if (c.length === 8) {
          month = c.substring(0, 2);
          day = c.substring(2, 4);
          year = c.substring(4, 8);
        }
      }
      if (isNaN(month) || isNaN(day) || isNaN(year)) {
        return true;
      }
      month = Number(month);
      day = Number(day);
      year = Number(year);
      if (month < 1 || month > 12) { // check month range
        return true;
      }
      if (day < 1 || day > 31) {
        return true;
      }
      if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
        return true;
      }
      if (year > Constants.SYBASE_SHORT_YEAR_MAX || year < Constants.LEGAL_YEAR_MIN) {
        return true;
      }
      if (month === 2) { // check for february 29th
        const isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
        if (day > 29 || (day === 29 && !isleap)) {
          return true;
        }
      }

    }
    return false;
  }

  validation() {
    this.validationMessages = [];
    this.showErrorDiv = false;
    if (this.coBoDOB.length > 0 && this.dateValidator(this.coBoDOB)) {
      this.validationMessages.push(Constants.PPA_COBO_DATE_VAL);
    }
    if (this.fhaCaseNum.length > 0 && this.fhaCaseNum.length < 13) {
      this.validationMessages.push(Constants.PPA_FHA_CAS_VAL);
    }
    if (this.monIncome.length > 0 && Number(this.monIncome) > 1000000) {
      this.validationMessages.push(Constants.PPA_MON_INCOM);
    }
    if (this.zip.length > 0 && this.zip.length < 5) {
      this.validationMessages.push(Constants.PPA_ZIP_CODE_VAL);
    }
    if (this.validationMessages.length > 0) {
      this.showErrorDiv = true;
      return false;
    }
    return true;
  }

  clearBtn() {
    this.lendrLnId = '';
    this.oldFannieLn = '';
    this.fhaCaseNum = '';
    this.address = '';
    this.city = '';
    this.zip = '';
    this.yrBuilt = '';
    this.noOfRoom = '';
    this.monIncome = '';
    this.coBoDOB = '';
    this.selectedDwel = null;
    this.selectedState = null;
    this.selectedUnit = null;
    this.selectedBorEthnicity = null;
    this.selectedBorGender = null;
    this.selectedBorRace = null;
    this.selectedCoBorEthnicity = null;
    this.selectedCoBorGender = null;
    this.selectedCoBorRace = null;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  dateFormatOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 47) {
      return false;
    }
    return true;
  }
}
